import { AuthState } from './auth-reducer';
import { AuthActions, AUTH_ACTION_TYPE } from './auth-type';

export const authCreators = {
  setAuthState: <KeyName extends keyof AuthState>(key: KeyName, value: AuthState[KeyName])
    : AuthActions => ({
      type: AUTH_ACTION_TYPE.SET_STATE,
      payload: { key, value }
    }),
  loginRequest: (): AuthActions => ({
    type: AUTH_ACTION_TYPE.LOGIN_REQUEST,
  }),
  loginSuccess: (data: any): AuthActions => ({
    type: AUTH_ACTION_TYPE.LOGIN_SUCCESS,
    payload: { data }
  }),
  loginError: (): AuthActions => ({
    type: AUTH_ACTION_TYPE.LOGIN_ERROR
  }),
  logOut: (): AuthActions => ({
    type: AUTH_ACTION_TYPE.LOGOUT
  }),
  checkAuthorization: (): AuthActions => ({
    type: AUTH_ACTION_TYPE.CHECK_AUTHORIZATION
  }),
};
